import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import {
	NgbToastModule,
	NgbProgressbarModule,
} from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { ForecastModule } from './forecast/forecast.module';
import { CallersModule } from './callers/callers.module';
import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';

//SORT TABLES
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	NgbPaginationModule,
	NgbTypeaheadModule,
} from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CountToModule } from 'angular-count-to';
import { NgApexchartsModule } from 'ng-apexcharts';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';

// Swiper Slider
import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import {
	NgbDropdownModule,
	NgbRatingModule,
	NgbNavModule,
} from '@ng-bootstrap/ng-bootstrap';

import { LightboxModule } from 'ngx-lightbox';

// Load Icons
import { defineLordIconElement } from 'lord-icon-element';
import lottie from 'lottie-web';

// Auto Complate
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

//views of customer portal
import { ViewsRoutingModule } from './views-routing.module';
import { SharedModule } from '../shared/shared.module';
import { WidgetModule } from '../shared/widget/widget.module';
import { EmployeeUsersModule } from './employee-users/employee-users.module';
import { DatePipe } from '@angular/common';
import { DateAgoPipe } from '../core/pipe/date-ago.pipe';
import { TablesModule } from '../pages/tables/tables.module';
import { ChartsModule } from '../pages/charts/charts.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductionBoardComponent } from './production-board/production-board.component';
import { WeekProductionComponent } from './production-board/week-production/week-production.component';
import { InventoryControlComponent } from './production-board/inventory-control/inventory-control.component';
import { BlackOutDaysComponent } from './black-out-days/black-out-days.component';
import { ClientUsersComponent } from './client-users/client-users.component';
import { EmployeeUsersComponent } from './employee-users/employee-users.component';
import { FyiDisposComponent } from './fyi-dispos/fyi-dispos.component';
import { QualityControlComponent } from './quality-control/quality-control.component';
import { ReplacementLeadsComponent } from './replacement-leads/replacement-leads.component';
import { RescheduleLeadsComponent } from './reschedule-leads/reschedule-leads.component';
import { UserEditComponent } from './employee-users/user-edit/user-edit.component';
import { AuthModulesComponent } from './employee-users/auth-modules/auth-modules.component';
import { BillingComponent } from './billing/billing.component';
import { ChargebackComponent } from './chargeback/chargeback.component';
import { CallerReportsComponent } from './caller-reports/caller-reports.component';
import { DispoReportsComponent } from './dispo-reports/dispo-reports.component';
import { CampaignEffortComponent } from './campaign-effort/campaign-effort.component';
import { LeadRankingComponent } from './lead-ranking/lead-ranking.component';
import { PhonePipe } from '../core/pipe/phone.pipe';
import { BillingAuthorizeComponent } from './billing-authorize/billing-authorize.component';
import { PayedLeadsComponent } from './billing/payed-leads/payed-leads.component';
import { NotPayedLeadsComponent } from './billing/not-payed-leads/not-payed-leads.component';
import { FormDatetimeComponent } from '../shared/forms-date/form-datetime/form-datetime.component';
import { FormRangeDateComponent } from '../shared/forms-date/form-range-date/form-range-date.component';
import { TableComponent } from '../shared/table/table.component';
import { LeadEditComponent } from '../shared/lead-edit/lead-edit.component';
import { CampaignAddComponent } from './campaigns/campaign-add/campaign-add.component';
import { CampaignEditComponent } from './campaigns/campaign-edit/campaign-edit.component';
import { CampaignCriteriaComponent } from './campaigns/campaign-edit/components/campaign-criteria/campaign-criteria.component';
import { CampaignEmployeeComponent } from './campaigns/campaign-edit/components/campaign-employee/campaign-employee.component';
import { SideMenuComponent } from './campaigns/campaign-edit/components/side-menu/side-menu.component';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { EditorModule } from '@tinymce/tinymce-angular';
import { PricingComponent } from './campaigns/campaign-edit/components/pricing/pricing.component';
import { UserWizardComponent } from '../shared/wizards/user-wizard/user-wizard.component';
import { ContractWizardComponent } from '../shared/wizards/contract-wizard/contract-wizard.component';
import { CampaignWizardComponent } from '../shared/wizards/campaign-wizard/campaign-wizard.component';
import { EditClientComponent } from './client-users/edit-client/edit-client.component';
import { ProspectsComponent } from './prospects/prospects.component';
import { ListUploadComponent } from './list-upload/list-upload.component';
import { BillingAuthorizeChaseComponent } from './billing-authorize-chase/billing-authorize-chase.component';
import { CallerTrackingComponent } from './caller-tracking/caller-tracking.component';
import { CallerTrackingDetailComponent } from './caller-tracking/caller-tracking-detail/caller-tracking-detail.component';
import { OnlineUserComponent } from './caller-tracking/online-user/online-user.component';
import { UserActionsComponent } from './user-actions/user-actions.component';
import { ViewsEmployeeComponent } from './permissions/views-employee/views-employee.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { ArchiveComponent } from './archive/archive.component';
import { CampaignWeekBoardComponent } from './production-board/campaign-week-board/campaign-week-board.component';
import { BillingReportComponent } from './billing-report/billing-report.component';
import { SupportTicketsComponent } from './support-tickets/support-tickets.component';
import { UsersComponent } from './users/users.component';
import { CommandCenterComponent } from './command-center/command-center.component';
import { NullToDashPipe } from '../core/pipe/nullToDash.pipe';
import { NotificationsComponent } from './notifications/notifications.component';
import { VeraAiChatComponent } from './vera-ai-chat/vera-ai-chat.component';
import { NewQcComponent } from './new-qc/new-qc.component';
import { AiAgentsComponent } from './ai-agents/ai-agents.component';
import { AvailablePhoneNumbersComponent } from './ai-agents/available-phone-numbers/available-phone-numbers.component';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
	direction: 'horizontal',
	slidesPerView: 'auto',
};
@NgModule({
	declarations: [
		AuthModulesComponent,
		BillingAuthorizeComponent,
		BillingComponent,
		BlackOutDaysComponent,
		CallerReportsComponent,
		CampaignEffortComponent,
		CampaignAddComponent,
		CampaignCriteriaComponent,
		CampaignEditComponent,
		CampaignEmployeeComponent,
		CampaignsComponent,
		ChargebackComponent,
		ClientUsersComponent,
		DateAgoPipe,
		DispoReportsComponent,
		LeadRankingComponent,
		EmployeeUsersComponent,
		FormDatetimeComponent,
		FormRangeDateComponent,
		FyiDisposComponent,
		InventoryControlComponent,
		LeadEditComponent,
		ListUploadComponent,
		NotPayedLeadsComponent,
		PayedLeadsComponent,
		PhonePipe,
		ProductionBoardComponent,
		QualityControlComponent,
		ReplacementLeadsComponent,
		RescheduleLeadsComponent,
		SideMenuComponent,
		TableComponent,
		UserEditComponent,
		WeekProductionComponent,
		PricingComponent,
		UserWizardComponent,
		ContractWizardComponent,
		CampaignWizardComponent,
		EditClientComponent,
		ProspectsComponent,
		BillingAuthorizeChaseComponent,
  		CallerTrackingComponent,
		CallerTrackingDetailComponent,
    	OnlineUserComponent,
		UserActionsComponent,
		ViewsEmployeeComponent,
		PermissionsComponent,
  		NotAuthorizedComponent,
		ArchiveComponent,
		CampaignWeekBoardComponent,
		BillingReportComponent,
		CommandCenterComponent,
		SupportTicketsComponent,
		UsersComponent,
		NullToDashPipe,
		NotificationsComponent,
		VeraAiChatComponent,
		NewQcComponent,
		AiAgentsComponent,
		AvailablePhoneNumbersComponent,
	],
	imports: [
		AutocompleteLibModule,
		CallersModule,
		ChartsModule,
		CommonModule,
		CountToModule,
		EditorModule,
		EmployeeUsersModule,
		FlatpickrModule,
		FlatpickrModule.forRoot(),
		FormsModule,
		FullCalendarModule,
		HttpClientModule,
		LeafletModule,
		LightboxModule,
		NgApexchartsModule,
		NgxDatatableModule,
		NgxDaterangepickerMd.forRoot(),
		NgbDropdownModule,
		NgbModule,
		NgbNavModule,
		NgbPaginationModule,
		NgbProgressbarModule,
		NgbRatingModule,
		NgbToastModule,
		NgbTooltipModule,
		NgbTypeaheadModule,
		ReactiveFormsModule,
		SimplebarAngularModule,
		SharedModule,
		SwiperModule,
		TablesModule,
		ViewsRoutingModule,
		WidgetModule,
		TranslateModule,
		NgbDropdownModule
	],
	exports: [TableComponent],
	providers: [
		DatePipe,
		DecimalPipe,
		{
			provide: SWIPER_CONFIG,
			useValue: DEFAULT_SWIPER_CONFIG,
		},
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ViewsModule {
	constructor() {
		defineLordIconElement(lottie.loadAnimation);
	}
}
